import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useAddPartnerNoteModal } from '../context/AddPartnerNoteModalContext';

const AddPartnerNoteModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddPartnerNoteModal();

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSavePartnerNote}
          disabled={data.text.length === 0}
        >
          {t('SaveAnnotation')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default AddPartnerNoteModalFooter;
